// import { Slider } from "antd";
import * as React from "react";
import styled from "styled-components";
import { syntheticColors } from "../../utils/synthetic-colors";
const tuple = (...args) => args;
export const themeTypes = tuple("light", "dark");
// tslint:disable:ter-max-len
// tslint:disable:jsx-no-lambda
// tslint:disable: variable-name
const Root = styled.div `
  &,
  * {
    transition: all 0.3s;
  }

  color: ${(props) => {
    return (props.theme === themeTypes[0]) ? props.colorPalette.mainBlackTransparentColor[6] : props.colorPalette.whiteColor[6];
}};
  border-radius: 8px;
  box-shadow: ${p => p.colorPalette.shadow[0]};
  padding: 6px 0px;
  background-color: ${(props) => {
    return (props.theme === themeTypes[0]) ? props.colorPalette.whiteColor[8] : syntheticColors(props.colorPalette.mainColor[8], props.colorPalette.blackColor[4]);
}};

  width: auto;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 12px;
    line-height: 12px;
    padding: 6px 12px;
    color: ${(props) => {
    return (props.theme === themeTypes[0]) ? props.colorPalette.mainBlackTransparentColor[6] : props.colorPalette.whiteColor[6];
}};
    text-align: center;
  }
  .unit {
    font-size: 12px;
    line-height: 12px;
    padding-bottom: 6px;
    text-align: center;
    color: ${(props) => {
    return (props.theme === themeTypes[0]) ? props.colorPalette.mainBlackTransparentColor[5] : props.colorPalette.whiteColor[5];
}};
  }
  .list {
    flex: 1 1 100%;
    color: ${(props) => {
    return (props.theme === themeTypes[0]) ? props.colorPalette.mainBlackTransparentColor[6] : props.colorPalette.whiteColor[6];
}};

    .ant-slider-mark-text-active {
      color: ${(props) => {
    return (props.theme === themeTypes[0]) ? props.colorPalette.mainBlackTransparentColor[6] : props.colorPalette.whiteColor[6];
}};
    }
  }
`;
// tslint:disable-next-line: variable-name
const Color = styled.div `
  background-color: ${props => props.color};
`;
/**
 * 基础图例，只包含标题，单位和边距
 *
 * @author 张卓诚
 * @date 2019-01-22
 * @export
 * @class BasicLegend
 * @extends {(React.PureComponent<BasicLegendProps & ICSSProps & ColorProps<GlobalColorPalette>>)}
 * @implements {ICSS}
 * @implements {Color<GlobalColorPalette>}
 * @example
 * <BasicLegend
 *   style={{
 *     position: "absolute",
 *     left: "100px",
 *     bottom: "5px"
 *   }}
 *    title="标题"
 *    unit="单位"
 *   colorPalette={globalColorPalette}
 * >
 * 内容
 * </BasicLegend>
 */
export class BasicLegend extends React.PureComponent {
    render() {
        // tslint:disable: jsx-no-multiline-js
        return (React.createElement(Root, { theme: this.props.theme, style: this.props.style, className: this.props.className, colorPalette: this.props.colorPalette },
            this.props.title ? (React.createElement("div", { className: "title" }, this.props.title)) : (undefined),
            this.props.unit ? (React.createElement("div", { className: "unit" }, this.props.unit)) : (undefined),
            React.createElement("div", { className: "list" }, this.props.children)));
    }
}
BasicLegend.defaultProps = {
    children: undefined,
    theme: themeTypes[0],
};
//# sourceMappingURL=index.js.map